/*
 *  -----------------------------------------------------------------------
 *    <copyright file="draggable-list.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ListBox, processListBoxDragAndDrop } from '@progress/kendo-react-listbox';
import React, { useState, useEffect } from 'react';
import './draggable-list.scss';

const DraggableList = ({
    data,
    onChangeCategory,
    onEditCategory,
}: {
    data: any[];
    onChangeCategory: Function;
    onEditCategory: Function;
}) => {
    const [items, setItems] = useState([]);
    const [state, setState] = useState({
        notDiscontinued: data.filter((product) => !product.Discontinued),
        discontinued: data.filter((product) => product.Discontinued),
        draggedItem: {},
    });

    useEffect(() => {
        setItems(data);
        setState({
            notDiscontinued: data.filter((product) => !product.Discontinued),
            discontinued: data.filter((product) => product.Discontinued),
            draggedItem: {},
        });
    }, [data]);

    const handleDragStart = (e: any) => {
        setState({ ...state, draggedItem: e.dataItem });
    };

    const handleDrop = (e: any) => {
        const result = processListBoxDragAndDrop(
            state.notDiscontinued,
            state.discontinued,
            state.draggedItem,
            e.dataItem,
            'key',
        );
        setState({
            ...state,
            notDiscontinued: result.listBoxOneData,
            discontinued: result.listBoxTwoData,
        });
        onChangeCategory([...result.listBoxOneData]);
    };

    const removeCategory = (index: number) => () => {
        const array = [...state.notDiscontinued];
        const element: any = array.splice(index, 1)[0];
        setItems(array);
        setState({
            ...state,
            discontinued: state.discontinued.filter((item: any) => item.key !== element.key),
            notDiscontinued: state.notDiscontinued.filter((item: any) => item.key !== element.key),
        });

        onChangeCategory([...array]);
    };

    const editCategory = (item: any, index: number) => () => {
        onEditCategory(state.notDiscontinued[index], index);
    };

    return (
        <div className="draggable-list">
            <div className="updating-buttons">
                {items.map((item: any, index: number) => (
                    <div className="updating-button">
                        <div className="icon-wrap">
                            <FontAwesomeIcon
                                icon={['fal', 'times']}
                                className="remove-icon"
                                onClick={removeCategory(index)}
                            />
                        </div>
                        <div className="icon-wrap">
                            <FontAwesomeIcon
                                icon={['fal', 'edit']}
                                className="edit-icon"
                                onClick={editCategory(item, index)}
                            />
                        </div>
                    </div>
                ))}
            </div>
            <ListBox
                data={state.notDiscontinued}
                textField="title"
                onDragStart={handleDragStart}
                onDrop={handleDrop}
                className="draggable-listbox"
            />
        </div>
    );
};

export default DraggableList;
